
<div class="table">

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="nombreEstudiante" sticky>
      <th mat-header-cell *matHeaderCellDef> Nombre del estudiante </th>
      <td mat-cell *matCellDef="let element"> {{element.nombreEstudiante}} </td>
    </ng-container>

    <ng-container matColumnDef="nombreMateria">
      <th mat-header-cell *matHeaderCellDef> Materia </th>
      <td mat-cell *matCellDef="let element"> {{element.nombreMateria}} </td>
    </ng-container>

    <ng-container matColumnDef="notaPeriodo1">
      <th mat-header-cell *matHeaderCellDef> Nota Periodo 1 </th>
      <td mat-cell *matCellDef="let element"> {{element.notaPeriodo1}} </td>
    </ng-container>

    <ng-container matColumnDef="porcentajePeriodo1">
      <th mat-header-cell *matHeaderCellDef> % Periodo 1 </th>
      <td mat-cell *matCellDef="let element"> {{element.porcentajePeriodo1}}% </td>
    </ng-container>

    <ng-container matColumnDef="notaPeriodo2">
      <th mat-header-cell *matHeaderCellDef> Nota Periodo 2 </th>
      <td mat-cell *matCellDef="let element"> {{element.notaPeriodo2}} </td>
    </ng-container>

    <ng-container matColumnDef="porcentajePeriodo2">
      <th mat-header-cell *matHeaderCellDef> % Periodo 2 </th>
      <td mat-cell *matCellDef="let element"> {{element.porcentajePeriodo2}}% </td>
    </ng-container>

    <ng-container matColumnDef="notaAcumulada">
      <th mat-header-cell *matHeaderCellDef> Nota Acumulada </th>
      <td mat-cell *matCellDef="let element">
        <mat-chip [ngClass]="element?.notaAcumulada < 3.0 ? 'custom-warn' : (element?.notaAcumulada > 3.0 && element?.notaAcumulada < 3.5) ? 'custom-accent' : '' "  selected>
          {{element.notaAcumulada}}
        </mat-chip>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
